module.exports = __webpack_public_path__ + "static/media/clockin.1baa6912.png";